var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1498 6.43343L3.03312 30.0001C2.74207 30.5041 2.58807 31.0756 2.58644 31.6576C2.58481 32.2397 2.73561 32.812 3.02383 33.3176C3.31206 33.8233 3.72767 34.2447 4.2293 34.5398C4.73094 34.835 5.30112 34.9937 5.88312 35.0001H34.1165C34.6985 34.9937 35.2686 34.835 35.7703 34.5398C36.2719 34.2447 36.6875 33.8233 36.9757 33.3176C37.264 32.812 37.4148 32.2397 37.4131 31.6576C37.4115 31.0756 37.2575 30.5041 36.9665 30.0001L22.8498 6.43343C22.5527 5.94361 22.1343 5.53863 21.6351 5.25757C21.1359 4.97651 20.5727 4.82886 19.9998 4.82886C19.4269 4.82886 18.8637 4.97651 18.3645 5.25757C17.8653 5.53863 17.4469 5.94361 17.1498 6.43343V6.43343Z",
    stroke: "#F9B803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V21.6667",
    stroke: "#F9B803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3333H20.0167",
    stroke: "#F9B803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.504c06c9c0509f8385f351cf4f07f381.svg";
export { ForwardRef as ReactComponent };